import objectUtil from '../../../../static/js/objectUtil'
import calculateUtil from '../../../../static/js/calculateUtil'
const getValue = objectUtil.getValueByPath
export default {
  onBatchSideSelect(dataArray, targetData, useBackCount, store, formData) {
    var batchData = dataArray.data,
      index = dataArray.dataIndex,
      filterParam = dataArray.filterParam,
      link = dataArray.link,
      extend = dataArray.extend
    var row = targetData[index]
    var gKey = !link ? 'goodsKeeping' : 'goodsStore'
    row[gKey] = batchData.goodsKeeping || row[gKey]
    if (!batchData.goodsKeeping) Object.keys(row[gKey]).forEach((im) => (row[gKey][im] = null))
    row[gKey].serialNumbers = null
    if (link) {
      // 需求6618将批号选择的 【仓库warehouse/货位location】 赋值给明细的【仓库outWarehouse/货位location】
      if (store && extend.mutlWarehouse) {
        row.outWarehouse = batchData.warehouse ?? null
        row.location = batchData.location ?? null //location
      }

      row.goodsStore.storageItemId = batchData.id ?? null
      row.goodsStore.storageDate = batchData.date ?? null
      row.goodsStore.available = batchData.available ?? null
      row.goodsStore.epc = batchData.epc ?? null
      row.goodsStore.deal = batchData.deal ?? null
      // #6386
      row.invoiceCode = batchData.invoiceCode ?? null
      // xq6492
      row.refcode = batchData?.refcode ?? null // 供应商来源单据号
      row.goodsStore.supplyService = batchData?.goodsKeeping?.supplyService ?? null //售后服务商
      row.settleType = batchData?.settleType ?? null //结算方式
      row.goodsStore.target = batchData?.goodsKeeping?.target ?? null //来源供应商
      // #6542
      row.contract = batchData?.contract ?? null
      // #7437
      if ('amountEdit' in batchData) row.amountEdit = batchData?.amountEdit
      // #8060
      row.goodsInfo.catalog = batchData?.goodsDetail?.catalog ?? null
      row.goodsInfo.natureName = batchData?.goodsDetail?.nature?.name ?? null
      // #9714
      row.goodsInfo.quantity = batchData?.goodsDetail?.quantity ?? null
      row.goodsInfo.collectPurchase = batchData?.goodsDetail?.collectPurchase ?? null
    }

    let inStorageDate = batchData.date ? calculateUtil.formatDate(new Date(batchData.date)) : null //新优联赋值入库日期
    // row.attrs.valueDate = { inStorageDate: inStorageDate }
    objectUtil.setValueByPath(row, 'attrs.valueDate.inStorageDate', inStorageDate)
    row.logistics = batchData.logistics ?? null
    row.location = batchData.location ?? null
    row.epc = batchData.epc ?? null
    //这里是云仓的内容 判断货主存在赋值
    if (batchData?.shipper) {
      row.shipper = batchData.shipper
    }
    row[!link ? 'warehouse' : 'outWarehouse'] = batchData.warehouse ?? null
    if (!link) {
      //将库存的客户部门更新到明细行里面 bug 44949
      row.customerDept = batchData.customerDept ?? null
      row.storageItem = {
        id: batchData.id ?? null,
        code: batchData.code ?? null,
      }
      //单独赋值storageItemId 手术配货单
      row.storageItemId = batchData.id
      //目前store 只有available 有值。
      row.storageAvailable = batchData.available ?? null
      row.stocking = batchData.stocking ?? null
      //优联特殊处理  选择批号后则添加业态
      row.deal = batchData.dealOne ?? null

      // 设置受托生产企业  委托生产备案批件 受托生产许可证
      objectUtil.setValueByPath(
        row,
        'attrs.valueEnum.entrustedManufacturer',
        batchData?.entrustedManufacturer ?? null
      )
      row['goodsKeeping']['entrustRegistration'] =
        batchData.goodsKeeping?.entrustRegistration ?? null
      row['goodsKeeping']['entrustedCertification'] =
        batchData.goodsKeeping?.entrustedCertification ?? null
    }

    //客户（迭代20增加）
    row.thirdparty = batchData.thirdparty ?? null

    //无税成本价
    row.netCost = batchData.netCost ?? null
    row.netCostDisplay = batchData.netCostDisplay ?? null
    //含税成本价
    row.cost = batchData.cost ?? null
    row.costDisplay = batchData.costDisplay ?? null
    //雷飞要求选批号时将税率带出
    // #38210, 浏览器版本过低会报错 Object.hasOwn(batchData, 'rate')
    if (!extend.notRate && batchData.hasOwnProperty('rate')) {
      row.rate = batchData.rate ?? null
    }
    //当前批次库存够用
    // if (row.amountDisplay || row.amountDisplay === 0 || row.amountDisplay === '0') {//不知道为什么加这个先做注释处理解决bug12177 【上海】供应链协同系统-发货单-发货单选择批号，添加数量后，重新选择或自动配货数量不会改变
    //   return;
    // } else
    //storageAvailableDisplay 库存可用量
    //planDisplay 上游计划数量
    if (!filterParam && batchData.hasOwnProperty('available')) {
      /**
       * #38792 产品在当前优化中重新梳理的逻辑如下：
       * A、当所选数据的“自定义序列号”无值情况下，就走之前的通用逻辑。
       * B、当所选数据的“自定义序列号”有值情况下，首先需要直接根据所选库存数据直接带入数量。然后数量是否允许编辑分两种情况：
       *   B1 如果当前商品档案的辅助单位没有维护【高值定数盒单位】，则数量不允许编辑。（对应定数包和真正的一物一码场景）
       *   B2 如果当前商品档案的辅助单位已经维护【高值定数盒单位】，则数量允许编辑。（对应定数盒场景）
       */
      if (batchData.epc) {
        // 有 EPC
        row.amount = batchData.available
      } else {
        // 没有 EPC
        let temp
        if (batchData.available > row.plan) {
          temp = row.plan
        } else {
          temp = batchData.available
        }
        if (!row.amount || row.amount > temp) {
          row.amount = temp
        }
      }
    }
    //extend.price 表示需要将库存中的含税成本价（cost）赋值给含税单价（price）
    if (store && !extend.price) {
      store.dispatch(useBackCount, filterParam ? 'amount' : 'amountBack', row, formData)
      store.dispatch(useBackCount, 'netMarginFn', row, formData) //计算毛利
    } else if (store && extend.price) {
      row.price = batchData.cost
      store.dispatch(useBackCount, 'price', row, formData)
    }
  },
  // crudArrayOrder  和 shoppingModel 拆分逻辑 方法
  handleMenuClickOfRowSplitRow(index, row, dataKey = 'data') {
    let splitRow = JSON.parse(JSON.stringify(row))
    //主行master强制置为false,计划数量置为null
    splitRow.plan = null
    splitRow.planDisplay = null
    splitRow.master = false
    splitRow.id = null
    splitRow.item = 0
    splitRow.amount = 0
    splitRow.amountDisplay = 0
    //需求 3326 迭代27
    //   splitRow.goodsKeeping = {
    //     "batchNumber": null,
    //     "registration": null
    //   }
    splitRow._ID = objectUtil.createID()
    // 灵科后端接口没有实现，目前暂时处理为，获取 goodsDetail 值 灵科就不需要去调接口 获取 注册证号的值
    if (
      splitRow.goodsDetail &&
      splitRow.goodsDetail.id &&
      this.SplitRowParam &&
      this.SplitRowParam.url
    ) {
      let dataOrConfig = {}
      if (this.SplitRowParam.param) {
        dataOrConfig = Object.assign({}, this.SplitRowParam.param)
      }
      if (dataOrConfig.parameters) {
        dataOrConfig.parameters.goodsId = splitRow[this.goodsDetailIndicate].id
        dataOrConfig.parameters.targetId = objectUtil.getValueByPath(
          this.parentVue?.formData,
          'order.target.organization.id'
        )
      }
      this.$axios[this.SplitRowParam.method](this.SplitRowParam.url, dataOrConfig)
        .then((res) => {
          if (!this.$cfn.ajax1.isOK(res, this)) return
          if (res.data.data && res.data.data.length == 1) {
            splitRow[this.link ? 'goodsStore' : 'goodsKeeping'].registration = res.data.data[0]
          }
          if (this.store) {
            this.store.dispatch(
              this.useBackCount,
              'amount',
              splitRow,
              getValue(this, 'parentVue.formData', {})
            )
          }
          getValue(this, dataKey).splice(index + 1, 0, splitRow)
          if (this.getTableData) this.getTableData()
        })
        .catch((res) => {
          console.error('拆分时获取注册证号:', res)
        })
    } else {
      if (this.store) {
        this.store.dispatch(
          this.useBackCount,
          'amount',
          splitRow,
          getValue(this, 'parentVue.formData', {})
        )
      }

      // this.data.splice(this.data.length - 1, 1);
      getValue(this, dataKey).splice(index + 1, 0, splitRow)
      console.log('splitRow: ', splitRow, getValue(this, dataKey))
      if (this.getTableData) this.getTableData()
    }
  },
}
